export default {
  title: 'New chat',
  form: {
    to: {
      label: 'To',
      placeholder: 'Enter phone number',
    },
    from: {
      label: 'From',
      placeholder: 'Select sender',
    },
    message: {
      label: 'Message',
      placeholder: 'Enter your message...',
    },
    buttons: {
      close: 'Close',
      create: 'Create',
    },
  },
}
